import { Breakpoint, Button, Divider, Slide } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { TransitionProps } from '@mui/material/transitions';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface AppDialogProps {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  children?: React.ReactNode;
  bottomDivider?: boolean;
  maxWidth?: Breakpoint | false;
  disableTransition?: boolean;
  isConfirm?: boolean;
}

const AppDialog: FC<AppDialogProps> = ({
  open,
  title,
  confirmText = 'common.ok',
  cancelText = 'common.cancel',
  onCancel,
  onConfirm,
  children,
  bottomDivider,
  maxWidth,
  disableTransition,
  isConfirm = true,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      fullWidth
      open={open}
      TransitionComponent={disableTransition ? undefined : Transition}
      maxWidth={maxWidth}
    >
      <DialogTitle>{t(title!)}</DialogTitle>
      <Divider sx={{ mx: 3 }} />
      <DialogContent>{children}</DialogContent>
      {bottomDivider && <Divider sx={{ mx: 3 }} />}
      <DialogActions>
        <Button onClick={onCancel}>{t(cancelText)}</Button>
        {isConfirm && (
          <Button onClick={onConfirm} autoFocus>
            {t(confirmText)}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AppDialog;
